import { CheckCircle, Target, Video } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Reveal } from "@/components/Reveal";

export const PillarsSection = () => {
  return (
    <section className="py-16 sm:py-20 lg:py-24 px-4 sm:px-6 lg:px-8">
      <div className="max-w-6xl mx-auto">
        <Reveal className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-primary mb-4">
            Respaldados por expertise real
          </h2>
          <p className="text-base sm:text-lg text-primary max-w-2xl mx-auto">
            No improvisamos. Nuestros dos pilares nos diferencian de cualquier agencia.
          </p>
        </Reveal>

        <div className="grid md:grid-cols-2 gap-6 lg:gap-8">
          {/* Pauta */}
          <Reveal delay={1}>
            <Card className="h-full border-border hover:border-accent transition-colors">
              <CardContent className="p-6 sm:p-8">
                <div className="flex items-center gap-3 mb-6">
                  <div className="p-3 bg-primary/30 rounded-xl">
                    <Target className="h-7 w-7 text-primary" />
                  </div>
                  <h3 className="text-xl sm:text-2xl font-bold text-primary">
                    Pauta Digital
                  </h3>
                </div>
                <p className="text-sm sm:text-base text-foreground/85 mb-6">
                  Equipo certificado que maximiza cada dólar invertido en publicidad.
                </p>
                <ul className="space-y-3">
                  {[
                    "Certificados en Meta, Google, TikTok y LinkedIn",
                    "Gestión de campañas enfocada en ROAS y CAC",
                    "Optimización semanal basada en datos reales",
                    "Reportes claros y accionables cada mes",
                    "Cobertura en +8 plataformas publicitarias",
                  ].map((item, i) => (
                    <li key={i} className="flex items-start gap-2.5">
                      <CheckCircle className="h-4 w-4 text-primary flex-shrink-0 mt-0.5" />
                      <span className="text-sm text-foreground/85">{item}</span>
                    </li>
                  ))}
                </ul>
              </CardContent>
            </Card>
          </Reveal>

          {/* Producción */}
          <Reveal delay={2}>
            <Card className="h-full border-border hover:border-accent transition-colors">
              <CardContent className="p-6 sm:p-8">
                <div className="flex items-center gap-3 mb-6">
                  <div className="p-3 bg-primary/30 rounded-xl">
                    <Video className="h-7 w-7 text-primary" />
                  </div>
                  <h3 className="text-xl sm:text-2xl font-bold text-primary">
                    Producción Audiovisual
                  </h3>
                </div>
                <p className="text-sm sm:text-base text-foreground/85 mb-6">
                  Equipo profesional con tecnología de primer nivel para contenido que impacta.
                </p>
                <ul className="space-y-3">
                  {[
                    "Cámaras profesionales de alta resolución",
                    "Drones para tomas aéreas cinematográficas",
                    "Teleprompter profesional para grabaciones fluidas",
                    "Iluminación y audio de estudio",
                    "Edición y postproducción incluidas",
                  ].map((item, i) => (
                    <li key={i} className="flex items-start gap-2.5">
                      <CheckCircle className="h-4 w-4 text-primary flex-shrink-0 mt-0.5" />
                      <span className="text-sm text-foreground/85">{item}</span>
                    </li>
                  ))}
                </ul>
              </CardContent>
            </Card>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
